<template>
  <div>
    <div v-if="show">
      <NoticeBar />
      <div class="agency-top">
        <img src="../../assets/images/bg_02.jpg" class="img" />
        <div class="agency-t-m">
          <div class="agency-t-m-1"><img :src="user.avatar" /></div>
          <div class="agency-t-m-2">
            <p class="u-name">{{ userInfo.username }}</p>
            <span class="u-phone" v-if="user.phone != '' && user.phone != null">{{ user.phone }}</span>
            <router-link to="/users/binding" v-else><span class="u-phone">绑定手机号</span></router-link>
            <div class="vip-tag">{{ userInfo.grade_name }}</div>
          </div>
        </div>
        <div class="agency-t-r">
          <div class="agency-t-r-w">
            <router-link to="/users/setting">
              <span>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-tubiao112"></use>
                </svg>
              </span>
              <p>设置</p>
            </router-link>
          </div>
          <div class="agency-t-r-w">
            <router-link to="/users/information">
              <van-badge>
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-xiaoxi"></use>
                  </svg>
                </span>
                <p>消息</p>
              </van-badge>
            </router-link>
          </div>
        </div>
      </div>
      <div class="u-orders">
        <h3 class="h3">我的订单</h3>
        <div class="u-o-m">
          <ul>
            <li>
              <router-link to="/users/orders?title=未付款">
                <van-badge :content="user.stay_pay_count" max="9">
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-daifukuan"></use>
                    </svg>
                  </span>
                  <p>未付款</p>
                </van-badge>
              </router-link>
            </li>
            <li>
              <router-link to="/users/orders?title=已付款">
                <van-badge :content="user.send_pay_count" max="9">
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-icon-test"></use>
                    </svg>
                  </span>
                  <p>待发货</p>
                </van-badge>
              </router-link>
            </li>
            <li>
              <router-link to="/users/orders?title=已发货">
                <van-badge :content="user.send_put_count" max="9">
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-yifahuo"></use>
                    </svg>
                  </span>
                  <p>待收货</p>
                </van-badge>
              </router-link>
            </li>
            <li>
              <router-link to="/users/orders">
              <span>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-dingdan1"></use>
                </svg>
              </span>
                <p>全部</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="user-a">
        <h3 class="h3"><img src="../../assets/images/ico_s_01.png" width="20" class="img" />账户余额</h3>
        <div class="u-b">
          <div class="u-b-li">
            <span class="price">{{ user.balance }}</span>
          </div>
        </div>
      </div>
      <div class="user-a">
        <h3 class="h3"><img src="../../assets/images/ico_s_01.png" width="20" class="img" />推广总分</h3>
        <div class="u-b">
          <div class="u-b-li">
            <span class="price">{{ user.account }}</span>
            <span class="info">推广奖励</span>
          </div>
          <div class="u-b-li">
            <span class="price">{{ user.freeze_account }}</span>
            <span class="info">未结算推广奖励</span>
          </div>
        </div>
        <!--
        <div class="u-c">
          <ul>
            <li><router-link to="/users/income?type=1">结算明细</router-link></li>
            <li><router-link to="/users/income?type=2">收支明细</router-link></li>
          </ul>
        </div>
        -->
      </div>
      <div class="user-c">
        <h3 class="h3">提现管理</h3>
        <ul>
          <li>
            <router-link to="/index/withdraw">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-tixian"></use>
                  </svg>
                </span>
              <p>申请提现</p>
            </router-link>
          </li>
          <li>
            <router-link to="/index/withdrawManage">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-tianchongxing-"></use>
                  </svg>
                </span>
              <p>提现记录</p>
            </router-link>
          </li>
          <li>
            <router-link to="/users/accountList">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-shoukuanzhanghao"></use>
                  </svg>
                </span>
              <p>收款账号</p>
            </router-link>
          </li>
          <li>
            <router-link to="/agency/sell">
              <span>
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-weixingongzhonghao"></use>
                </svg>
              </span>
            </router-link>
            <p>团队统计</p>
          </li>
        </ul>
      </div>
      <div class="user-c" v-if="user.pt_status == 1">
        <h3 class="h3">平台管理</h3>
        <ul>
          <li v-if="user.a_status == 1">
            <router-link to="/manage/recharge">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-tixian"></use>
                  </svg>
                </span>
              <p>会员充值</p>
            </router-link>
          </li>
          <li v-if="user.a_status == 1 || user.a_status == 2">
            <router-link to="/manage/orders">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-dingdan1"></use>
                  </svg>
                </span>
              <p>订单管理</p>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- <div class="user-b">
        <ul>
          <li>
            <a @click="upgrade">
              <img src="../../assets/images/ico_01.png" width="60" />
              <span>会员升级</span>
            </a>
          </li>
          <li>
            <router-link to="/agency/index">
              <img src="../../assets/images/ico_02.png" />
              <span>代理专区</span>
            </router-link>
          </li>
          <li>
            <router-link to="">
              <img src="../../assets/images/ico_03.png" />
              <span>游戏规则</span>
            </router-link>
          </li>
          <li>
            <router-link to="/users/questions">
              <img src="../../assets/images/ico_04.png" />
              <span>常见问题</span>
            </router-link>
          </li>
        </ul>
      </div> -->
      <!--
      <div class="user-d">
        <h3 class="h3"><img src="../../assets/images/ico_s_02.png" width="20" class="img" />货款<span class="u-d-recharge"><router-link to="">充值<van-icon name="arrow" class="ico" /></router-link></span></h3>
        <div class="u-d-price">
          <span>0.00</span>
        </div>
        <ul class="u-d-ul">
          <li><router-link to="">充值申请</router-link></li>
          <li><router-link to="">贷款明细</router-link></li>
        </ul>
      </div>
      <div class="user-c">
        <h3 class="h3">我的应用</h3>
        <ul>
          <li>
            <router-link to="">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-shoukuanzhanghao"></use>
              </svg>
            </span>
              <p>收款账号</p>
            </router-link>
          </li>
          <li>
            <router-link to="">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-lingshouguanliretail"></use>
              </svg>
            </span>
              <p>试用装</p>
            </router-link>
          </li>
          <li>
            <router-link to="">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-peixun"></use>
              </svg>
            </span>
              <p>培训</p>
            </router-link>
          </li>
          <li>
            <router-link to="">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-huodong"></use>
              </svg>
            </span>
              <p>活动</p>
            </router-link>
          </li>
          <li>
            <router-link to="">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-gengduo"></use>
              </svg>
            </span>
              <p>更多</p>
            </router-link>
          </li>
        </ul>
      </div>
      -->
    </div>

    <van-popup v-model="rwmShow"><img src="../../assets/images/rwm.jpg" width="200" /><p class="rmg-gz">长按关注公众号</p></van-popup>
    <Footer />
    <Laod ref="laoding" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Icon, Badge, Popup, Dialog } from 'vant'

  export default {
    components: {
      [Icon.name]: Icon,
      [Badge.name]: Badge,
      [Popup.name]: Popup,
      [Dialog.Component.name]: Dialog.Component,
    },
    name: 'index',
    data() {
      return {
        rwmShow: false,
        show: false,
        user: [],
        userInfo: this.$store.state
      }
    },
    created () {
      if(this.userInfo.name != null) {
        this.userInfo.username = this.userInfo.name
      }else if(this.userInfo.nickname != null) {
        this.userInfo.username = this.userInfo.nickname
      }
      this.getUser()
    },
    methods: {
      showPopup() {
        this.rwmShow = true;
      },
      getUser() {
        this.$api.get('user', null, r=>{
          this.user = r.data
          if(r.data.stay_pay_count === 0){
            this.user.stay_pay_count = ''
          }
          if(r.data.send_pay_count === 0){
            this.user.send_pay_count = ''
          }
          if(r.data.send_put_count === 0){
            this.user.send_put_count = ''
          }
          this.show = true
          this.$refs.laoding.loadClose()
        })
      },
      upgrade() {
        if(this.$store.state.phone != '' && this.$store.state.phone != null){
          if(this.user.members_grade_id === 1) {
            this.$toast('您已经是最高等级啦')
          }else if(this.user.upgrade_members_grade_id == 2){
            this.$toast('您的升级订单还未支付')
          }else if(this.user.upgrade_members_grade_id == 1){
            this.$toast('您的升级订单已经在审核中啦')
          }else{
            this.$router.push({name: 'upgrade'})
          }
        }else{
          Dialog.alert({
            message: '您还未绑定手机号，请绑定后再升级！',
          }).then(() => {
            this.$router.push({name: 'binding'})
          })
        }
      }
    }
  }
</script>

<style scoped>
  .u-orders{
    background: #ffffff;
    padding:10px 0;
    overflow: hidden;
  }
  .u-orders .h3{
    margin: 0;
    font-size: 15px;
    font-weight: normal;
    padding:0 15px 10px;
    border-bottom: 1px solid #eff1f3;
  }
  .u-orders .h3 .u-o-more{
    float: right;
    font-size: 15px;
  }
  .u-orders .h3 .u-o-more .ico{
    font-size: 20px;
    float: right;
  }
  .u-orders .u-o-m{

  }
  .u-orders .u-o-m ul li{
    float: left;
    width: 25%;
    text-align: center;
  }
  .u-orders .u-o-m ul li a{
    display: block;
    padding:15px 0 5px;
  }
  .u-orders .u-o-m ul li span{
    font-size: 30px;
  }
  .u-orders .u-o-m ul li p{
    margin: 0;
    font-size: 14px;
  }

  .user-a{
    margin-top: 10px;
    overflow: hidden;
    padding:10px 15px;
    background: #ffffff;
  }
  .user-a .h3{
    margin: 0;
    font-size: 15px;
    font-weight: normal;
  }
  .user-a .h3 .img{
    float: left;
    margin-right: 5px;
  }
  .user-a .u-b{
    overflow: hidden;
    padding:15px 0;
  }
  .user-a .u-b .u-b-li{
    width: 41%;
    float: left;
    border-right: 1px solid #DCDEE0;
    padding:0 4%;
  }
  .user-a .u-b .u-b-li:last-child{
    border-right: none;
  }
  .user-a .u-b .u-b-li span{
    display: block;
  }
  .user-a .u-b .u-b-li .price{

  }
  .user-a .u-b .u-b-li .info{
    color:#969799;
    font-size: 12px;
    margin-top: 3px;
  }
  .user-a .u-c{
    overflow: hidden;
  }
  .user-a .u-c ul li{
    float: left;
    background: #FFFBE8;
    border-radius: 3px;
    width: 46%;
    margin:2%;
  }
  .user-a .u-c ul li a{
    color:#ed6a0c;
    display: block;
    text-align: center;
    padding:3% 0;
    font-size: 14px;
  }
  .user-b{
    margin-top: 10px;
    padding:15px 0;
    overflow: hidden;
    background: #ffffff;
  }
  .user-b ul li{
    float: left;
    width: 25%;
    text-align: center;
  }
  .user-b ul li a img{
    width: 60%;
  }
  .user-b ul li a span{
    display: block;
    font-size: 14px;
  }
  .user-c{
    background: #ffffff;
    padding:15px;
    margin-top: 10px;
    overflow: hidden;
  }
  .user-c .h3{
    font-size: 15px;
    font-weight: normal;
    margin:0;
  }
  .user-c ul li{
    float: left;
    width: 25%;
    text-align: center;
    padding-top:10px;
  }
  .user-c ul li span{
    font-size: 30px;
  }
  .user-c ul li p{
    margin: 0;
    font-size: 14px;
  }
  .user-d{
    margin-top: 10px;
    background: #ffffff;
    padding:10px 15px;
    overflow: hidden;
  }
  .user-d .h3{
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }
  .user-d .h3 .img{
    float: left;
    margin-right: 5px;
  }
  .user-d .h3 .u-d-recharge{
    float: right;
    font-size: 15px;
  }
  .user-d .h3 .u-d-recharge .ico{
    font-size: 20px;
    float: right;
  }
  .user-d .u-d-price{
    font-size: 14px;
    padding:10px 15px;
  }
  .user-d .u-d-ul li{
    float: left;
    background: #FFFBE8;
    border-radius: 3px;
    width: 46%;
    margin:2%;
  }
  .user-d .u-d-ul li a{
    color:#ed6a0c;
    display: block;
    text-align: center;
    padding:3% 0;
    font-size: 14px;
  }
  .rmg-gz{
    text-align: center;
    margin: 0;
    font-size: 14px;
    padding-bottom: 10px;
  }
  .vip-tag{
    font-size: 13px;
    color:#fff;
    margin-top:3px;
    margin-left:5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/users/index.vue